import React from "react";
import { pointsConfig } from "../../../../pointsConfig";

function MilesRankDetailBadgesSection({ badges }) {
  const codes = Object.values(pointsConfig.badges);
  const loadedBadges = badges?.map((badge) => {
    const iconCode =
      codes.find((code) => code.code === badge.iconCode)?.active ||
      codes[0].active;
    return {
      icon: iconCode,
      label: badge.title,
    };
  });

  if (loadedBadges?.length === 0) return <></>;

  return (
    <div className="flex flex-col w-full mt-6">
      <span className="font-BrFirmaBold text-lg mb-2">Badges</span>
      <div className="flex gap-4 flex-wrap w-full justify-between">
        {loadedBadges.map((badge, index) => (
          <div
            key={index}
            className="flex w-[48%] h-28 rounded-xl items-center gap-2 border border-black/10 p-4 bg-white"
          >
            <img src={badge.icon} alt="" className="w-20 object-contain" />
            <span className="">{badge.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MilesRankDetailBadgesSection;
